export enum HealthFacilityField {
  ID = "id",
  NAME = "Name",
}
